import Image from "next/image";
import { useRouter } from "next/navigation";

const Logo = () => {
  const router = useRouter();

  const handleHomeClick = () => {
    router.push("/");
  };

  return (
    <button
      onClick={handleHomeClick}
      className="relative aspect-[256/74] w-full max-w-30"
    >
      <Image
        className="object-contain"
        src="/images/logo.webp"
        alt="Color to Life Logo"
        fill
        priority
        loading="eager"
        sizes="( max-width: 768px ) 120px, 150px"
        quality={60}
      />
    </button>
  );
};

export default Logo;
